var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { computed, reactive } from "vue";
import presetsService from "./presets-service";
export const useProgramsPageStore = defineStore("programsPageStore", () => {
    const state = reactive({
        results: [],
        favorites: [],
        tagsConfiguration: {},
    });
    const fetchPresets = () => __awaiter(void 0, void 0, void 0, function* () {
        const [favoritePrograms, tagsConfigurationProperty] = yield presetsService.fetchPresets();
        state.favorites = favoritePrograms;
        state.tagsConfiguration = tagsConfigurationProperty;
    });
    const initialize = () => __awaiter(void 0, void 0, void 0, function* () {
        yield fetchPresets();
    });
    const updateTagsConfiguration = (payload) => {
        return new Promise((resolve, reject) => {
            presetsService
                .saveTagsConfigurations(payload.tagsConfiguration)
                .then(() => {
                fetchPresets();
                resolve();
            })
                .catch(() => reject());
        });
    };
    const updateFavorites = (payload) => {
        return new Promise((resolve, reject) => {
            presetsService
                .saveFavorites(payload.favoritesConfiguration)
                .then(() => {
                fetchPresets();
                resolve();
            })
                .catch(() => reject());
        });
    };
    const listFavorites = computed(() => {
        return state.favorites;
    });
    const listTagsConfiguration = computed(() => {
        return state.tagsConfiguration;
    });
    return {
        initialize,
        fetchPresets,
        updateFavorites,
        updateTagsConfiguration,
        listFavorites,
        listTagsConfiguration,
    };
});
